const map = {
	"./aduanas/auctions/store/index.js": "./src/febos/aduanas/auctions/store/index.js",
	"./aduanas/batches/store/index.js": "./src/febos/aduanas/batches/store/index.js",
	"./aduanas/dashboard/store/index.js": "./src/febos/aduanas/dashboard/store/index.js",
	"./aduanas/management/entities/store/index.js": "./src/febos/aduanas/management/entities/store/index.js",
	"./aduanas/management/products/store/index.js": "./src/febos/aduanas/management/products/store/index.js",
	"./aduanas/management/warehouses/store/index.js": "./src/febos/aduanas/management/warehouses/store/index.js",
	"./aduanas/receipts/store/index.js": "./src/febos/aduanas/receipts/store/index.js",
	"./aduanas/successfulBidder/store/index.js": "./src/febos/aduanas/successfulBidder/store/index.js",
	"./chile/docDigital/store/index.js": "./src/febos/chile/docDigital/store/index.js",
	"./global/kanban/store/index.js": "./src/febos/global/kanban/store/index.js"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/febos sync recursive store\\/index.js$";